<template>
  <div class="">
    <Landing :landingData="landingData" />
    <Stats />
    <!-- <Types /> -->
    <Works />
    <ProgramInfo id="program" :info="programData" />
    <BasicRequirement />
    <Need />

    <PartnerCompanies />
    <Contact bgColor="#3A3A4C" />
  </div>
</template>

<script>
import Landing from '../components/Homev2/Recruit/LandingRecruit.vue'
import Contact from '../components/isaMain/Contact.vue'
import BasicRequirement from '../components/Homev2/Recruit/WhyChoose.vue'
import PartnerCompanies from '../components/Homev2/Recruit/PartnerCompanies.vue'
import Stats from '../components/Homev2/Recruit/Stats.vue'
// import Types from '../components/Homev2/Recruit/TypesIsa.vue'
import Works from '../components/Homev2/Recruit/Works.vue'
import Need from '../components/Homev2/Recruit/NeededFromCompanies.vue'

export default {
  data() {
    return {
      landingData: {
        title: 'One-stop Solution to All of Your Hiring Needs',
        paragraph:
          'We have trained about 5000+ people so far in the areas of Data Science, Machine Learning, UX/UI, Digital Marketing and Artificial Intelligence. Let us help you hire the right talent with our assessment based process in the most efficient way. ',
        quizLink:
          'https://quiz.upskill.com.bd/assessment/37a6c7d6-f21c-48e1-968e-74336c5109c3?public=true&job=isa_financial_analyst',
        landingImage: require('../assets/homeV2/Recruiter/Frame (1).png'),
      },

      howWillitPay: {
        numericalColor: '#1EBCE5',
        stepsTextColor: '#EA4424',
        steps: [],
        quizLink:
          'https://quiz.upskill.com.bd/assessment/37a6c7d6-f21c-48e1-968e-74336c5109c3?public=true&job=isa_financial_analyst',
        companyName: 'CMED',
      },
    }
  },
  components: {
    Landing,
    Contact,
    BasicRequirement,
    PartnerCompanies,
    Stats,
    // Types,
    Works,
    Need,
  },
  created() {
    this.Loaded()
  },
}
</script>

<style></style>
